import { Component, EventEmitter, Inject, Input, Output, SimpleChanges } from '@angular/core';
import { Store } from '@ngrx/store';
import { find } from 'lodash';
import { ModalsService } from '../../../../shared/modals/modals.service';
import { ObjectCache } from '../../../../shared/services/object-cache/object-cache.service';
import { IStudent } from '../../../../shared/typings/interfaces/student.interface';
import { IStudentPath } from '../../../../shared/typings/interfaces/studentPaths.interface';
import { ListDisplay } from '../list-display.component';
import { ListDisplayService } from '../list-display.service';
import { MilestonesKeyMap } from './../../../../shared/constants/milestones.constant';
import { StudentPathStatuses } from './../../../../shared/constants/student-paths.constant';
import { UpdateMilestone } from './../../../../store/actions/milestone-actions';
import { UpdateStudentPath } from './../../../../store/actions/student-paths-actions';

const { COMMITTED, COMMITTED_WITH_SPECIAL_OPP } = StudentPathStatuses;
@Component({
  selector: 'list-display-milestone',
  template: require('./list-display-milestone.component.html'),
  styles: [require('./list-display-milestone.scss')],
})
export class ListDisplayMilestone extends ListDisplay {
  @Input() milestones;
  @Input() student: IStudent;
  @Input() studentPaths: IStudentPath[];
  @Input() isViewOnlyUser: boolean;

  @Output() saveStudent: EventEmitter<any> = new EventEmitter();

  constructor(
    protected listViewService: ListDisplayService,
    protected objectCache: ObjectCache,
    @Inject('$state') protected $state: any,
    private modalsService: ModalsService,
    private ngrxStore: Store<any>,
  ) {
    super(listViewService, objectCache, $state, ngrxStore);
  }

  ngOnChanges(changes: SimpleChanges) {
    this.parsedData = this.milestones;
    super.ngOnChanges(changes);
  }

  rowClick(dataRow): void {
    const {
      data,
      dependencies: { isCalculated, disabled },
    } = dataRow[0];
    if (this.isViewOnlyUser) return;
    if (isCalculated) {
      if (!disabled) {
        if (data === MilestonesKeyMap.OPP_PROGRAM_ELL_CONFIRM.humanName) this._openEOPModal();
        else if (data === MilestonesKeyMap.FINAL_DECISION.humanName) this._openFinalDecisionModal();
        else return;
      }
    } else {
      const { checked, docId } = dataRow[0].dependencies;
      const status = checked ? 'NOT_COMPLETE' : 'COMPLETE';
      const patch = { status };
      const payload = {
        docId,
        patch,
        schoolId: this.student.schoolId,
      };
      this.store.dispatch(new UpdateMilestone(payload));
    }
  }

  _openEOPModal(): void {
    const milestones = this.milestones.sections[0].data;
    const eopMilestone = find(milestones, (row: any) => {
      return row.milestone.data === 'EOP financial eligibility confirmation';
    });
    this.modalsService
      .openEOPMilestoneModal({
        student: this.student,
        eopMilestone,
      })
      .afterClosed()
      .subscribe(result => {
        if (result) {
          const newValue = result === '—' ? null : result;
          const patch = {
            eopFinancialEligibility: newValue,
          };
          this.saveStudent.emit({ patch, path: 'eopFinancialEligibility' });
        }
      });
  }

  _openFinalDecisionModal(): void {
    const milestones = this.milestones.sections[0].data;
    const finalDecisionMilestone = find(milestones, (row: any) => {
      return row.milestone.data === 'Final decision';
    });
    this.modalsService
      .openFinalDecisionMilestoneModal({
        student: this.student,
        finalDecisionMilestone,
        studentPaths: this.studentPaths,
      })
      .afterClosed()
      .subscribe(result => {
        if (result) {
          const payload = {
            studentPathId: result.studentPathId,
            status: result.status,
            planDowngrade: null,
            schoolId: this.student.schoolId,
            studentId: this.student._id,
          };
          // if student has path with 'Comitted' status, downgrade that path
          // before changing the status of the selected path (JE)
          const pathWithPlan = find(this.studentPaths, (studentPath: IStudentPath) => {
            const { status } = studentPath;
            return status === COMMITTED || status === COMMITTED_WITH_SPECIAL_OPP;
          });
          if (pathWithPlan) {
            let newStatus;
            const { acceptanceStatus, applicationStatus } = pathWithPlan;
            if (acceptanceStatus) newStatus = acceptanceStatus;
            else if (applicationStatus) newStatus = applicationStatus;
            else newStatus = 'Plans to apply'; // If no prior status is found, default to lowest status (JE)
            payload.planDowngrade = {
              pathToDowngrade: pathWithPlan._id,
              newStatus,
            };
            this.ngrxStore.dispatch(new UpdateStudentPath(payload));
          } else {
            this.ngrxStore.dispatch(new UpdateStudentPath(payload));
          }
        }
      });
  }
}
